const moduleMap = {
	"./organizations": () => {
		return __webpack_require__.e(820).then(() => (() => ((__webpack_require__(4820)))));
	},
	"./createOrganization": () => {
		return __webpack_require__.e(981).then(() => (() => ((__webpack_require__(1981)))));
	},
	"./editOrganization": () => {
		return __webpack_require__.e(187).then(() => (() => ((__webpack_require__(5187)))));
	},
	"./detailOrganization": () => {
		return __webpack_require__.e(779).then(() => (() => ((__webpack_require__(9779)))));
	},
	"./extensiones": () => {
		return __webpack_require__.e(709).then(() => (() => ((__webpack_require__(5709)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});